<template>
    <div>
        <div class="row">
            <div class="col-sm-8 explain_big">
                <div class="position-fixed">
                    <div class="back">
                        <a href="/menu"><img src="/static/tutorial/back.png" alt=""></a>
                    </div>
                    <div class="nav">
                        <nav class="navbar navbar-expand-lg text-center" style="background-color:#F0F0F0; border:#A0A0A0 solid 1px; padding:10px; font-size:0.8rem; color:black;">
                            <div class="collapse navbar-collapse" id="navbarNavDropdown">
                                <ul class="navbar-nav">
                                    <li class="nav-item mr-3">
                                        <a class="nav-link" @click="indexChange(1)"><img :src="datas[1].img" alt=""><br>돌출<span></span></a>
                                    </li>
                                    <li class="nav-item dropdown mr-2">
                                        <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <img :src="datas[2].img" alt=""><br>모깎기
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a class="dropdown-item" @click="indexChange(2)"><img :src="datas[2].img" alt="" >모깎기</a>
                                        <a class="dropdown-item" @click="indexChange(3)"><img :src="datas[3].img" alt="" >모따기</a>
                                        </div>
                                    </li>
                                    <li class="nav-item mr-3">
                                        <a class="nav-link"><img :src="datas[4].img" alt="" @click="indexChange(4)"><br>리볼브</a>
                                    </li>
                                    <li class="nav-item mr-3">
                                        <a class="nav-link"><img :src="datas[5].img" alt="" @click="indexChange(5)"><br>로프트</a>
                                    </li>
                                    <li class="nav-item mr-3">
                                        <a class="nav-link"><img :src="datas[6].img" alt="" @click="indexChange(6)"><br>쉘</a>
                                    </li>
                                    <li class="nav-item mr-3">
                                        <a class="nav-link"><img :src="datas[7].img" alt="" @click="indexChange(7)"><br>오프셋</a>
                                    </li>
                                    <li class="nav-item mr-3" style="border-left:0.5px solid; color:#C5C5C5">
                                    </li>
                                    <li class="nav-item mr-3">
                                        <a class="nav-link"><img :src="datas[8].img" alt="" @click="indexChange(8)"><br>합치기</a>
                                    </li>
                                    <li class="nav-item mr-3">
                                        <a class="nav-link"><img :src="datas[9].img" alt="" @click="indexChange(9)"><br>빼기</a>
                                    </li>
                                    <li class="nav-item mr-3">
                                        <a class="nav-link"><img :src="datas[10].img" alt="" @click="indexChange(10)"><br>교차영역</a>
                                    </li>
                                    <li class="nav-item mr-2">
                                        <a class="nav-link"><img :src="datas[11].img" alt="" @click="indexChange(11)"><br>면 합치기</a>
                                    </li>
                                    <li class="nav-item dropdown mr-2">
                                        <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <img :src="datas[12].img" alt="" ><br>모델 자르기
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a class="dropdown-item" @click="indexChange(12)"><img :src="datas[12].img" alt="">모델 자르기</a>
                                        <a class="dropdown-item" @click="indexChange(13)"><img :src="datas[13].img" alt="">분리하기</a>
                                        </div>
                                    </li>
                                    <li class="nav-item mr-3" style="border-left:0.5px solid; color:#C5C5C5">
                                    </li>
                                    <li class="nav-item dropdown mr-2">
                                        <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <img :src="datas[14].img" alt="" ><br>이동/회전
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a class="dropdown-item" @click="indexChange(14)"><img :src="datas[14].img" alt="">이동/회전</a>
                                        <a class="dropdown-item" @click="indexChange(15)"><img :src="datas[15].img" alt="">정렬</a>
                                        <a class="dropdown-item" @click="indexChange(16)"><img :src="datas[16].img" alt="">길이 조절</a>
                                        <a class="dropdown-item" @click="indexChange(17)"><img :src="datas[17].img" alt="">전체 비율</a>
                                        <a class="dropdown-item" @click="indexChange(18)"><img :src="datas[18].img" alt="">축 비율</a>
                                        </div>
                                    </li>
                                    <li class="nav-item dropdown">
                                        <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <img :src="datas[19].img" alt=""><br>반복 복제
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a class="dropdown-item" @click="indexChange(19)"><img :src="datas[19].img" alt="">반복 복제</a>
                                        <a class="dropdown-item" @click="indexChange(20)"><img :src="datas[20].img" alt="">회전 복제</a>
                                        <a class="dropdown-item" @click="indexChange(21)"><img :src="datas[21].img" alt="">대칭 복제</a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                    <img :src=datas[index].img alt="" style="height:100px">
                    <h1>{{datas[index].subject}}</h1>
                    <div class="explain_detail">
                        <p>{{datas[index].explain[0].ex1}}</p>
                        <p>{{datas[index].explain[0].ex2}}</p>
                        <div class="explain_order ml-2 ">
                            <p>{{datas[index].explain[0].ex3}}</p>
                            <p>{{datas[index].explain[0].ex4}}</p>
                            <p>{{datas[index].explain[0].ex5}}</p>
                            <p>{{datas[index].explain[0].ex6}}</p>
                        </div>
                    </div>
                    <div class="explain_button pt-5">
                        <button @click="prevButton()" :disabled='index == 0'>이전</button>
                        <button @click="nextButton()" :disabled='index == datas.length -1'>다음</button>
                    </div>
                </div>

            </div>
            <div class="col-sm-4 explain_img">
                <div class="img_list " v-for="data in 6" v-bind:key="data.index">
                    <img :src="datas[index].imgex[data-1]" alt="" style="width:100%">
                </div>
            </div>
        </div>
        
        <js/>
    </div>
</template>


<script>
export default {
    data() {
        return {
            subject: undefined,
            img: undefined,
            explain: [],
            index: 0,
            datas: [
                {
                    index: 0,
                    img: ' ',
                    subject:'편집',
                    explain:
                        [
                            {
                                ex1: '| 기본 도형에 효과를 주거나 형태를 변형시키는 기능들로 구성되어 있는 메뉴입니다.', 
                                ex2: '| 편집 공통 사항', 
                                ex3: '1. 편집 내 도구들은 도구를 사용하고 대상을 선택하거나, 먼저 대상을 선택한 뒤에 도구를 사용할 수도 있습니다.', 
                                ex4: '2. 도구 사용 시 정확하게 선을 선택하거나, 면을 선택해야 작동되는 도구들이 있으니 주의해야 합니다.',
                                ex5: '3. 도구 선택 후 효과 적용을 위한 수치를 입력하고 적용을 누르면 도구들이 적용됩니다.', 
                                ex6: '4. 일부 도구의 경우 수치 이외에 선택 가능한 옵션이 있습니다.'
                            },
                        ],
                    imgex: ['']
                },
                {
                    index: 1,
                    img: '/static/tutorial/2. 오브젝트/1. 돌출.png',
                    subject:'돌출(E)',
                    explain:
                        [
                            {
                                ex1: '| 선택한 2D 또는 3D 도형의 면을 선택하여 입력한 수치만큼 돌출 시키는 기능', 
                                ex2: '| 돌출의 옵션', 
                                ex3: '- 합치기 : 돌출되는 영역과 기존 개체를 한 덩어리로 병합', ex4: '- 빼기 : 돌출되는 영역만큼 다른 3D 모델을 모델을 제거',
                                ex5: '- 교차영역 : 돌출되는 영역을 제외한 나머지 부분을 제거', ex6: '- 생성 : 기존 개체와 별개로 모델을 생성'
                            },
                        ],
                    imgex: ['/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0034_돌출-선택.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0033_돌출-합치기.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0032_돌출-빼기.png',
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0031_돌출-교차영역.png',
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0030_돌출-생성.png']
                },
                {
                    index: 2,
                    subject:'모깎기(F)',
                    img: '/static/tutorial/2. 오브젝트/2. 모깎기.png',
                    explain:
                        [
                            {
                                ex1: '| 선택한 2D 스케치 또는 면을 선택하여 입력한 수치만큼 둥글게 깎는 기능',
                                ex2: '| 모깎기 사용하기', 
                                ex3: '1. 모서리가 있는 도형을 준비한다.', 
                                ex4: '2. 모깎기를 적용할 선을 먼저 선택하고 모깎기 도구를 선택하거나, 도구를 선택한 다음 모깎기를 적용할 선을 선택한다.',
                                ex5: '3. 원하는 수치를 입력하여 효과를 적용한다.'
                            },
                        ],
                    imgex: ['/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0029_모깎기-선택.png',
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0028_모깎기-적용.png']
                },
                {
                    index: 3,
                    subject:'모따기(C)',
                    img: '/static/tutorial/2. 오브젝트/3. 모따기.png',
                    explain:
                        [
                            {ex1: '| 선택한 2D 스케치 또는 면을 선택하여 입력한 수치만큼 사선으로 깎는 기능', ex2: '| 모따기 사용하기', 
                            ex3: '1. 모서리가 있는 도형을 준비한다.', ex4: '2. 모따기를 적용할 선을 먼저 선택하거나, 도구를 선택한 다음 모따기를 적용할 선을 선택한다.',
                            ex5: '3. 원하는 수치를 입력하여 효과를 적용한다.'},
                        ],
                    imgex: ['/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0027_모따기-선택.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0026_모따기-적용.png'] 
                },
                {
                    index: 4,
                    subject:'리볼브(R)',
                    img: '/static/tutorial/2. 오브젝트/4. 리볼브.png',
                    explain:
                        [
                            {ex1: '| 중심축이 될 선을 기준으로 면을 선택하여 최대 360도까지 회전시켜 모양을 만드는 기능', ex2: '| 리볼브 사용하기', 
                            ex3: '1. 중심축의 위치 지정을 위해 상자를 불러온다.', ex4: '2. 중심축을 기준으로 회전시킬 단면을 준비한다.',
                            ex5: '3. 도구를 선택한 다음 중심축을 선택하고 회전시킬 단면을 선택한다.', ex6: '4. 원하는 수치를 입력하여 효과를 적용한다.'},
                        ],
                    imgex: ['/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0025_리볼브-축선택.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0024_리볼브-면선택.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0023_리볼브-적용.png'] 
                },
                {
                    index: 5,
                    subject:'로프트(L)',
                    img: '/static/tutorial/2. 오브젝트/5. 로프트.png',
                    explain:
                        [
                            {ex1: '| 2D 스케치 또는 면을 선택하여 선택된 면끼리 연결된 형태의 모양을 만드는 기능', ex2: '| 로프트 사용하기', 
                            ex3: '1. 연결시킬 다수의 면들을 준비한다.', ex4: '2. 도구를 선택한 다음 면들의 위치를 순서대로 클릭하여 효과를 적용한다.',
                            ex5: '3. 한번에 하나씩 선택할 때와 동시에 모두 선택할 때의 모양이 달라진다.'},
                        ],
                    imgex: ['/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0022_로프트-선택', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0021_로프트-적용1.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0020_로프트-적용2.png'] 
                },
                {
                    index: 6,
                    subject:'쉘(S)',
                    img: '/static/tutorial/2. 오브젝트/6. 쉘.png',
                    explain:
                        [
                            {ex1: '| 선택한 3D 모델에 입력한 수치만큼 껍질 모양의 모델링을 생성하는 기능', ex2: '| 쉘 사용하기', 
                            ex3: '1. 작업 가능한 3D 모델을 준비한다.(2D 또는 합치기로 인해 선이 복잡한 모델은 작업 불가능)', ex4: '2. 쉘 작업을 할 면을 먼저 선택하거나, 도구를 선택한 다음 쉘을 적용할 면을 선택한다.',
                            ex5: '3. 원하는 수치만큼 +수치로 입력하면 바깥으로, -수치로 입력하면 안으로 테두리가 생성된다.'},
                        ],
                    imgex: ['/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0019_쉘-선택.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0018_쉘-적용.png',] 
                },
                {
                    index: 7,
                    subject:'오프셋(O)',
                    img: '/static/tutorial/2. 오브젝트/7. 오프셋.png',
                    explain:
                        [
                            {ex1: '| 선택한 2D 스케치 또는 3D모델의 면을 선택하여 수치만큼 이동한 테두리 면을 생성하는 기능', ex2: '| 오프셋 사용하기', 
                            ex3: '1. 2D 스케치 또는 3D 모델을 준비한다.', ex4: '2. 테두리를 만들 면을 먼저 선택하거나, 도구를 선택한 다음 테두리를 만들 면을 선택한다.',
                            ex5: '3. 원하는 수치만큼 +수치로 입력하면 바깥으로, -수치로 입력하면 안으로 새로운 테두리가 생성된다.'},
                        ],
                    imgex: ['/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0017_오프셋-선택.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0016_오프셋-적용.png'] 
                },
                {
                    index: 8,
                    subject:'합치기(U)',
                    img: '/static/tutorial/2. 오브젝트/8. 합치기.png',
                    explain:
                        [
                            {ex1: '| 선택한 모든 도형을 하나의 개체로 합치는 기능', ex2: '| 합치기 사용하기', 
                            ex3: '1. 2개 이상의 3D 모델을 준비한다.', ex4: '2. 도구를 선택한 다음 순서에 관계 없이 합치고 싶은 모든 3D 모델을 선택한다.',
                            ex5: '3. 적용을 눌러 하나로 합쳐진 것을 확인한다.'},
                        ],
                    imgex: ['/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0015_합치기-선택.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0014_합치기-적용.png',]  
                },
                {
                    index: 9,
                    subject:'빼기(Y)',
                    img: '/static/tutorial/2. 오브젝트/9. 빼기.png',
                    explain:
                        [
                            {ex1: '| 처음 선택한 도형에서 두번째로 선택한 도형의 모양을 빼내는 기능', ex2: '| 빼기 사용하기', 
                            ex3: '1. 남겨둘 모델과 빼낼 2D 스케치 또는 3D 모델을 겹쳐있게 준비한다.', ex4: '2. 도구를 선택한 다음 남겨둘 모델을 먼저 선택하고 빼낼 개체를 선택한다.',
                            ex5: '3. 적용을 눌러 모양을 확인한다. 만약 순서가 달라진다면 모양이 크게 달라지니 주의한다.'},
                        ],
                    imgex: ['/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0013_빼기-선택.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0012_빼기-적용.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0011_빼기-적용-2.png']  
                },
                {
                    index: 10,
                    subject:'교차영역(I)',
                    img: '/static/tutorial/2. 오브젝트/10. 교차영역.png',
                    explain:
                        [
                            {ex1: '| 선택한 두 도형의 교집합 부분만 남기는 기능', ex2: '| 교챠영역 사용하기', 
                            ex3: '1. 2D 스케치 또는 3D 모델을 겹쳐있게 준비한다.', ex4: '2. 도구를 선택한 다음 순서에 관계 없이 교차영역으로 지정할 개체를 선택한다.',
                            ex5: '3. 적용을 눌러 교집합 부분만 남은 것을 확인한다.'},
                        ],
                    imgex: ['/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0010_교차영역-선택.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0009_교차영역-적용.png']  
                },
                {
                    index: 11,
                    subject:'면 합치기(M)',
                    img: '/static/tutorial/2. 오브젝트/12. 면합치기.png',
                    explain:
                        [
                            {ex1: '| 같은 좌표 내에 겹쳐있는 면들을 선택하여 하나의 면으로 정리하는 기능', ex2: '| 면 합치기 사용하기', 
                            ex3: '1. STL 파일 또는 합치기로 한 면에 선이 여러개인 3D 모델을 준비한다.', ex4: '2. 도구를 선택한 다음 정리하고 싶은 3D 모델을 선택한다.',
                            ex5: '3. 하나로 합치고 싶은 면들을 다중 선택한다.', ex6:'4. 적용을 눌러 면들이 깔끔하게 정리되어 있는 것을 확인한다.'},
                        ],
                    imgex: ['/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0005_면합치기-준비.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0004_면합치기-선택.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0003_면합치기-적용.png']  
                },
                {
                    index: 12,
                    subject:'모델 자르기',
                    img: '/static/tutorial/2. 오브젝트/13. 모델 자르기.png',
                    explain:
                        [
                            {ex1: '| 2D 스케치의 위치를 기준으로 3D 모델을 잘라내는 기능', ex2: '| 모델 자르기 사용하기', 
                            ex3: '1. 3D 모델을 준비하고 자르고 싶은 위치에 2D 스케치를 배치한다.', ex4: '2. 도구를 선택한 다음 3D 모델을 먼저 선택하고 앞서 위치시킨 2D 스케치를 선택한다.',
                            ex5: '3. 적용을 누른 뒤 개체들을 이동시켜 모델이 잘린 것을 확인한다.'},
                        ],
                    imgex: ['/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0002_모델-자르기-준비.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0001_모델-자르기-선택.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0000_모델-자르기-적용.png']  
                },
                {
                    index: 13,
                    subject:'분리하기(P)',
                    img: '/static/tutorial/2. 오브젝트/11. 분리하기.png',
                    explain:
                        [
                            {ex1: '| 데이터상 떨어져 있지만 하나의 개체로 되어 있는 모델을 분리하는 기능', ex2: '| 분리하기 사용하기', 
                            ex3: '1. 데이터상 하나로 묶여 있는 2D 스케치 또는 3D 모델을 준비한다.', ex4: '2. 도구를 선택한 다음 분리시킬 개체를 선택한다.',
                            ex5: '3. 개체들을 이동시켜 각자 떨어져 잇는 것을 확인한다.'},
                        ],
                    imgex: ['/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0008_분리하기-준비.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0007_분리하기-선택.png', 
                    '/static/tutorial/2. 오브젝트/캡쳐/오브젝트_0006_분리하기-적용.png']  
                },
                {
                    index: 14,
                    img: '/static/tutorial/3. 편집/1. 이동회전.png',
                    subject:'이동/회전(T)',
                    explain:
                        [
                            {
                                ex1: '| 선택된 개체를 원하는 위치로 이동시키거나 회전시키는 기능', 
                                ex2: '| 이동/회전 사용하기', 
                                ex3: '1. 2D 또는 3D 개체를 준비한다.', ex4: '2. 이동할 때는 X Y Z 축 방향의 화살표를 드래그하여 움직이거나 수치를 직접 입력한다.',
                                ex5: '3. 이동할때는 X Y Z 축 방향의 화살표를 드래그하여 움직이거나 수치를 직접 입력한다.', ex6: '4. 회전할때는 X Y Z 축 방향의 핸들을 드래그하여 회전사거나 수치를 직접 입력한다.',
                                ex7: '5. 화면 우측 하단에 있는 그리드스냅 또는 회전 스냅을 조정하면 원하는 단위로 이동/회전한다.'
                            },
                        ],
                    imgex: ['/static/tutorial/3. 편집/캡쳐/_0037_이동회전-선택.png', 
                    '/static/tutorial/3. 편집/캡쳐/_0036_이동회전-선택2.png', 
                    '/static/tutorial/3. 편집/캡쳐/_0035_이동회전-이동.png',
                    '/static/tutorial/3. 편집/캡쳐/_0034_이동회전-회전.png',
                    '/static/tutorial/3. 편집/캡쳐/_0033_그리드스냅.png']
                },
                {
                    index: 15,
                    subject:'정렬(A)',
                    img: '/static/tutorial/3. 편집/4. 정렬.png',
                    explain:
                        [
                            {ex1: '| 선택된 개체들을 가로 세로 높이 기준 3점으로 정렬할 수 있는 기능', ex2: '| 정렬 사용하기', 
                            ex3: '1. 2D 또는 3D 개체를 준비한다.', ex4: '2. 정렬할 개체를 먼저 선택하거나, 도구를 선택한 다음 Ctrl키로 정렬할 개체를 선택한다.',
                            ex5: '3. 각 점을 기준으로 왼쪽 정렬, 중앙 정렬, 오른쪽 정렬을 할 수 있다.', ex6: '( 빨강 : 가로 | 초록 : 세로 | 파랑 : 높이 )'},
                        ],
                    imgex: ['/static/tutorial/3. 편집/캡쳐/_0024_정렬-선택.png', 
                    '/static/tutorial/3. 편집/캡쳐/_0023_정렬-선택2.png', 
                    '/static/tutorial/3. 편집/캡쳐/_0022_정렬-적용.png',
                    '/static/tutorial/3. 편집/캡쳐/_0021_정렬-적용2.png'] 
                },
                {
                    index: 16,
                    subject:'길이 조절(H)',
                    img: '/static/tutorial/3. 편집/2. 길이조절.png',
                    explain:
                        [
                            {
                                ex1: '| 선택된 개체의 길이를 기준으로 크기를 변경하는 기능',
                                ex2: '| 길이 조절 사용하기', 
                                ex3: '1. 2D 또는 3D 개체를 준비한다.', 
                                ex4: '2. 변경할 개체를 먼저 선택하고 길이 조절 도구를 선택하거나, 도구를 선택한 다음 변경할 개체를 선택한다.',
                                ex5: '3. 가로-세로-높이 기준으로 길이를 수정하여 크기를 변경한다.'
                            },
                        ],
                    imgex: ['/static/tutorial/3. 편집/캡쳐/_0032_길이조절-선택.png', 
                    '/static/tutorial/3. 편집/캡쳐/_0031_길이조절-선택2.png', 
                    '/static/tutorial/3. 편집/캡쳐/_0030_길이조절-적용.png'] 
                },
                {
                    index: 17,
                    subject:'전체 비율',
                    img: '/static/tutorial/3. 편집/3. 전체 비율.png',
                    explain:
                        [
                            {ex1: '| 선택된 개체의 비율을 기준으로 크기를 변경할 수 있는 기능', ex2: '| 전체 비율 / 축 비율 사용하기', 
                            ex3: '1. 2D또는 3D 개체를 준비한다.', ex4: '2. 변경할 개체를 먼저 선택하고 도구를 선택하거나, 도구를 선택한 다음 변경할 개체를 선택한다.',
                            ex5: '3. 전체비율 또는 축비율을 선택한다.', ex6: '4. 전체비율은 일괄적으로 조정하고 축비율은 가로 세로 높이별로 따로 조정 가능하다.',
                            ex7: '5. 원본크기 1을 기준으로 수치를 입력하여 크기를 변경할수 있다. (2배는 2입력 절반은 0.5 입력)'},
                        ],
                    imgex: ['/static/tutorial/3. 편집/캡쳐/_0029_비율조절-선택.png', 
                    '/static/tutorial/3. 편집/캡쳐/_0028_전체비율-선택.png', 
                    '/static/tutorial/3. 편집/캡쳐/_0027_전체비율-적용.png'] 
                },
                {
                    index: 18,
                    subject:'축 비율',
                    img: '/static/tutorial/3. 편집/3. 축 비율.png',
                    explain:
                        [
                            {ex1: '| 선택된 개체의 비율을 기준으로 크기를 변경할 수 있는 기능', ex2: '| 전체 비율 / 축 비율 사용하기', 
                            ex3: '1. 2D또는 3D 개체를 준비한다.', ex4: '2. 변경할 개체를 먼저 선택하고 도구를 선택하거나, 도구를 선택한 다음 변경할 개체를 선택한다.',
                            ex5: '3. 전체비율 또는 축비율을 선택한다.', ex6: '4. 전체비율은 일괄적으로 조정하고 축비율은 가로 세로 높이별로 따로 조정 가능하다.',
                            ex7: '5. 원본크기 1을 기준으로 수치를 입력하여 크기를 변경할수 있다. (2배는 2입력 절반은 0.5 입력)'},
                        ],
                    imgex: ['/static/tutorial/3. 편집/캡쳐/_0026_축비율-선택.png',
                    '/static/tutorial/3. 편집/캡쳐/_0025_축비율-적용.png'] 
                },
                {
                    index: 19,
                    subject:'반복 복제',
                    img: '/static/tutorial/3. 편집/9. 반복 복제.png',
                    explain:
                        [
                            {ex1: '| 선택된 개체에 적용된 이동/회전 수치 만큼 개체를 복제하는 기능', ex2: '| 반복 복제 사용하기', 
                            ex3: '1. 2D 또는 3D 개체를 준비한다.', ex4: '2. 반복 복제할 개체를 선택하여 도구를 사용하여 이동 또는 회전 값을 지정한다.',
                            ex5: '3. 도구를 사용하여 개체를 복제한다.'},
                        ],
                    imgex: ['/static/tutorial/3. 편집/캡쳐/편집_0014_반복복제-선택.png', 
                    '/static/tutorial/3. 편집/캡쳐/편집_0013_반복복제-선택2.png', 
                    '/static/tutorial/3. 편집/캡쳐/편집_0012_반복복제-적용.png',
                    '/static/tutorial/3. 편집/캡쳐/편집_0011_반복복제-적용2.png'] 
                },
                {
                    index: 20,
                    subject:'회전 복제',
                    img: '/static/tutorial/3. 편집/10. 대칭 복제.png',
                    explain:
                        [
                            {ex1: '| 중심축이 될 선을 기준으로 선택한 도형을 회전시키면서 복제하는 기능', ex2: '| 회전 복제 사용하기', 
                            ex3: '1. 중심축 또는 임의로 생성한 2D 또는 3D 개체를 준비한다.', 
                            ex4: '2. 중심축이 될 선을 선택한 뒤 복제 할 개체를 선택한다.',
                            ex5: '3. 원하는 수치를  입력하여 개체를 원하는 대로 복제할 수 있다.'},
                        ],
                    imgex: ['/static/tutorial/3. 편집/캡쳐/편집_0010_회전복제-선택.png', 
                    '/static/tutorial/3. 편집/캡쳐/편집_0009_회전복제-선택2.png', 
                    '/static/tutorial/3. 편집/캡쳐/편집_0008_회전복제-적용.png',
                    '/static/tutorial/3. 편집/캡쳐/편집_0007_회전복제-적용2.png'] 
                },
                {
                    index: 21,
                    subject:'대칭 복제',
                    img: '/static/tutorial/3. 편집/10. 대칭 복제.png',
                    explain:
                        [
                            {ex1: '| 대칭 복제는 중심축이 될 선을 기준으로 개체를 선택 한 뒤 방향을 선택하여 복제하는 기능', ex2: '| 대칭 복제 사용하기', 
                            ex3: '1. 2D 또는 3D 개체를 준비한다.', 
                            ex4: '2. 대칭 복제할 개체를 먼저 선택하거나, 도구를 선택한 다음 작업할 개체를 선택한다.',
                            ex5: '3. 대칭시킬 원본 개체를 먼저 선택하고 복제의 중심이 될 중심축을 선택하여 도형을 복제한다.',
                            ex6:'4. 중심축을 선택 할 때 Shift키를 누른 채 선택 하면 Z축 방향으로 복제한다.'},
                        ],
                    imgex: ['/static/tutorial/3. 편집/캡쳐/_0010_대칭-선택.png', 
                    '/static/tutorial/3. 편집/캡쳐/_0009_대칭-선택2.png', 
                    '/static/tutorial/3. 편집/캡쳐/_0008_대칭-적용.png',
                    '/static/tutorial/3. 편집/캡쳐/_0007_대칭-적용2.png'] 
                },
                
            ]
        } 
    },
    created() {
        this.push(this.index);
    },
    methods: {
        nextButton() {
            this.index = this.index + 1;
            window.scrollTo(0,0);
        },
        prevButton() {
            this.index = this.index - 1;
            window.scrollTo(0,0);
        },
        push(index) {
            this.subject =  this.datas[index].subject
            this.img = this.datas[index].img
            this.explain = [this.datas[index].explain[index].ex1, this.datas[index].explain[index].ex2, this.datas[index].explain[index].ex3, this.datas[index].explain[index].ex4, this.datas[index].explain[index].ex5, this.datas[index].explain[index].ex6]
            this.imgex = this.datas[index].imgex
        
        },
        indexChange(index){
            this.index = index;
            window.scrollTo(0,0);
        },
        myFunction() {
            document.getElementById("myDropdown").classList.toggle("show");
        },
        myFunction2() {
            document.getElementById("myDropdown2").classList.toggle("show");
        } 
    }
    
}
</script>

<style scoped>
    
    p {
        color: black;
    }
    .explain_big {
        padding: 0 8vw;
        margin-top: 8vw;
        float: left;
    }

    h1 {
        font-size: 25px;
        color: black;
        font-weight: 700;

    }

    .explain_detail p{
        padding: 0px;
        margin: 0px;

    }

    .explain_order p{
        margin: 0px;
        padding: 0px;
    }

    button{
        border-radius: 30px;
        padding: 3px 30px;
        margin: 10px;
        border-color: lightgray;
        border-style: solid;
        background-color: white;
        font-size: 0.8rem;
        outline: 0;
    }
    .explain_img {
        right: 0;
        width: 100%;
        padding-top: 150px;
        background-color: white;
    }
    .img_list {
        float: right;
    }
    .back img{
        margin-left: -100px;
        width: 35px;
        height: 35px;
        box-shadow: none;
        display: flex;
        position: fixed;
    }
    
    .navBar img{
        display: flex;
        width: 100%;
        height: auto;
    }
    .nav-item{
        display: block;
        cursor: pointer;
    }

    .nav-item img{
        width: 35px;
        height: 35px;
        margin-bottom: 0.3vw;
    }

    .dropdown-menu img{
        width: 18px;
        height: 18px;
        margin-right: 10px;
    }
    .dropdown-menu a{
        font-size: 15px;
    }
    .nav{
        margin-bottom: 6vw;
    }
    a { color: inherit; } 
    
</style>


// WEBPACK FOOTER //
// src/pages/explain_test.vue